export const parsePermissions = (rows = []) => {
  const map = {};

  rows.forEach(r => {
    if (!r.IsActive || r.IsDeleted) return;

    if (!map[r.Module_Id]) {
      map[r.Module_Id] = new Set();
    }

    map[r.Module_Id].add(r.Permission_Id);
  });

  return map;
};